"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Tabs = require("../Tabs");
var _Text = require("../../../components/Text/Text.util");
var _createUseStyles = _interopRequireDefault(require("../../../themes/createUseStyles"));
var _defaultProps = _interopRequireDefault(require("../../../utils/defaultProps"));
var _pickAndRemoveFromObject = _interopRequireDefault(require("../../../utils/pickAndRemoveFromObject"));
var _commonProps = require("../../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../../utils/vars/initVars"));
var _excluded = ["className", "label", "selected", "overrides"];
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var common = _commonProps.defaultCommonProps;
var vars = (0, _initVars.default)({
  applied: common
});
var Tab = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
    label = _ref.label,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$overrides = _ref.overrides,
    overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var expand = (0, _react.useContext)(_Tabs.TabsContext);
  var classes = useStyles((0, _pickAndRemoveFromObject.default)(otherProps, common));
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    ref: ref,
    className: (0, _classnames.default)(classes.variables, classes.root, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, classes.expand, expand), classes.contentSize, !expand), classes.indicator, !expand && selected), classes.selected, selected), className, overrides.root)
  }, otherProps), /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)(classes.label, _defineProperty({}, classes.selected, selected), overrides.label)
  }, label));
});
var styles = function styles(theme) {
  return {
    variables: vars.styles,
    root: _objectSpread(_objectSpread({
      outline: 0,
      background: "transparent",
      height: theme.spacing.base * 6,
      position: "relative",
      fontFamily: theme.typography.fontFamily
    }, (0, _Text.setTextCssVars)({
      fontWeight: theme.typography.fontWeight,
      fontSize: theme.typography.fontSize + 2,
      color: theme.colors.baseContrast090,
      lineHeight: 1
    })), {}, {
      textTransform: "capitalize",
      cursor: "pointer",
      border: "none",
      "&:hover": {
        background: theme.colors.baseContrast015
      }
    }),
    label: {
      pointerEvents: "none",
      "& :first-child": {
        display: "inline-flex",
        alignItems: "center"
      },
      "& svg": {
        marginInlineEnd: theme.spacing.base / 2
      }
    },
    expand: {
      width: "100%",
      padding: [theme.spacing.base, 0]
    },
    contentSize: {
      width: "unset",
      padding: [theme.spacing.base, theme.spacing.base * 2]
    },
    indicator: {
      borderBottom: "solid 2px ".concat(theme.colors.primary),
      padding: [theme.spacing.base, theme.spacing.base * 2, theme.spacing.base - 2, theme.spacing.base * 2]
    },
    selected: {}
  };
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "Tab"
});
Tab.displayName = "Tab";
var Storybook = exports.Storybook = Tab;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/navigation-tabs--docs
 */
var exportedComponent = (0, _defaultProps.default)(Tab);
exportedComponent.displayName = "Tab";
var _default = exports.default = exportedComponent;